module.exports = __webpack_public_path__ + "img/header.c4afdcf8.png";